import React from "react";

import cssClasses from "./TokenPaymentStatusModal.module.css";
import Close from "../../Components/Icons/Close";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import Datagrid from "../../Subcomponents/Datagrid";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";

export default function TokenPaymentStatusDetailsModal({
  open,
  handleClose,
  data,
  popupType,
}) {

  console.log("data pop", data)
  const prerequisite = () => {
    const findPrerequisite = data.find(
      (el) => el?.eventTokenId?.prerequisiteId
    );
    const prerequisiteName =
      findPrerequisite &&
      findPrerequisite?.eventTokenId?.prerequisiteId?.tokenId?.name;
    return prerequisiteName;
  };

  function convertId(idString) {
    const year = idString.slice(0, 4);
    const month = idString.slice(4, 6);
    const day = idString.slice(6, 8);
    const sequence = idString.slice(8);

    const formattedId = `VJ${year}${month}${day}-${sequence}`;

    return formattedId;
  }

  const rowsData =
    data.length > 0 &&
    data?.map((el, i) => {
      return {
        id: i,
        salesPerson: el?.leadId?.userId?.name,
        leadName: el?.leadId,
        Status: el?.status,
      };
    });

  const columns = [
    {
      field: "salesPerson",
      headerName: "Sales Person",
      width: 300,
      renderCell: (params) => {
        return (
          <div className={cssClasses.FirstTitle}>{params.row?.salesPerson}</div>
        );
      },
    },
    {
      field: "leadName",
      headerName: "Lead Name",
      width: 300,
      renderCell: (params) => {
        return (
          <div>
            <p> {params.row?.leadName?.personId?.name}</p>
            <p style={{ opacity: "0.7" }}>
              {convertId(params.row?.leadName?.leadDisplayId)}
            </p>
          </div>
        );
      },
    },
    {
      field: "Status",
      headerName: "Status",
      width: 250,
      renderCell: (params) => {
        return (
          <>
            {" "}
            {params.row.Status && (
              <LeadStatusChip
                label={params.row.Status}
                style={
                  params.row.Status === "pending"
                    ? { color: "#B54708", backgroundColor: "#FFFAEB" }
                    : params.row.Status === "partial"
                    ? {
                        color: "rgb(192, 16, 72)",
                        backgroundColor: "rgb(255, 241, 243)",
                      }
                    : { color: "#027A48", backgroundColor: "#ECFDF3" }
                }
                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
              />
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={cssClasses.container}>
          <div className={cssClasses.header} style={{ marginBottom: "2rem" }}>
            <p className={cssClasses.heading}>
              {popupType}
              {prerequisite() && (
                <small
                  style={{
                    fontSize: "10px",
                    marginLeft: "2rem",
                    fontWeight: "400",
                    lineHeight: "13.64px",
                    fontStyle: "italic",
                    opacity: "0.7",
                  }}
                >
                  Prerequisite: {prerequisite()}
                </small>
              )}
            </p>
            <Box
                    ml={"auto"}
                    mt={1}
                    onClick={handleClose}
                    style={{ cursor: "pointer" }}
                  >
                    <Close width={"1.2rem"} height={"1.2rem"} />
                  </Box>
          </div>
          <div className={cssClasses.gridWrapper}>
            {
              <Datagrid
                hideFooter={false}
                columns={columns}
                rows={rowsData || []}
              />
            }
          </div>
        </div>
      </Modal>
    </>
  );
}
